module.exports = __webpack_public_path__ + "static/media/bg3.30e4c70d.jpg";